import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromAdmin from './admin.reducers';

export interface AdminState {
  stateData: fromAdmin.State;
}

export interface State extends fromRoot.AppState {
  admin: AdminState;
}

export const reducers = {
  stateData: fromAdmin.reducer
};

export const selectAdminState = createFeatureSelector<AdminState>('admin');

export const selectAdminStateData = createSelector(selectAdminState, (state: AdminState) => state.stateData);

export const getAdminState = createSelector(selectAdminStateData, fromAdmin.getStateData);

export const getAdminScreenError = createSelector(selectAdminStateData, fromAdmin.getError);

export const getAdminScreenPending = createSelector(selectAdminStateData, fromAdmin.getPending);